//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import pullAt from 'lodash/pullAt';
export default {
  name: 'NiotaClassicDevicetypesPacketParserCalculation',
  mixins: [formMixin, parserTypesMixin],
  props: {
    calculateElements: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      calculateElementsInternal: []
    };
  },
  watch: {
    calculateElements: {
      handler: function handler(val) {
        var clonedPropCalculateElements = cloneDeep(val);
        this.calculateElementsInternal = clonedPropCalculateElements;

        if (clonedPropCalculateElements.length === 0) {
          this.addCalculateElement(0);
        }
      },
      immediate: true
    }
  },
  methods: {
    emitChanges: function emitChanges() {
      var clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      this.$emit('config-updated', clonedCalculateElements);
    },
    requiredRuleForVariable: function requiredRuleForVariable(cElement) {
      var _this = this;

      return function (v) {
        var bothEmpty = !cElement.formula && !cElement.target;

        if (bothEmpty) {
          return true;
        }

        return _this.requiredRule[0](v);
      };
    },
    parserTargetNameRule: function parserTargetNameRule(cElement) {
      var _this2 = this;

      return function (v) {
        var bothEmpty = !cElement.formula && !cElement.target;

        if (bothEmpty) {
          return true;
        }

        if (!v) {
          return _this2.$i18n_t('Common.fieldRequired');
        }

        return /^[a-zA-Z0-9_\\.]+$/.exec(v) !== null || _this2.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variableNameRule');
      };
    },
    addCalculateElement: function addCalculateElement(index) {
      var clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      clonedCalculateElements.splice(index + 1, 0, {
        target: '',
        formula: ''
      });
      this.calculateElementsInternal = clonedCalculateElements;
    },
    removeCalculateElement: function removeCalculateElement(index) {
      var clonedCalculateElements = cloneDeep(this.calculateElementsInternal);
      pullAt(clonedCalculateElements, [index]);
      this.calculateElementsInternal = clonedCalculateElements;
      this.emitChanges();
    },
    revalidateForm: function revalidateForm() {
      this.$emit('validate-form');
    },
    onInputsChanged: function onInputsChanged() {
      this.revalidateForm();
      this.emitChanges();
    }
  }
};